var React = require('react');

function Birthday (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20.782,5.346c-1.434-1.515-4.047-2.859-7.768-3.995l-.344-.105-1.193,1.099c-.223-.059-.457-.091-.699-.091-1.507,0-2.728,1.221-2.728,2.728,0,.164.014.324.042.48l-6.004,5.53v11.761l19.823-4.121V7.626c.011-.243-.037-1.126-1.128-2.28ZM20.655,14.293l-17.311,3.69v-2.674l17.311-3.69v2.674ZM3.344,11.784l17.311-3.413v1.963L3.344,14.025v-2.24ZM10.778,7.71c1.507,0,2.728-1.221,2.728-2.728,0-.789-.335-1.499-.87-1.997l.354-.326c3.939,1.241,5.821,2.518,6.71,3.38.454.441.692.812.817,1.08l-15.739,3.103,3.856-3.551c.5.633,1.274,1.04,2.143,1.04ZM3.344,21.21v-1.944l17.311-3.69v2.035l-17.311,3.599Z","fill":"#010101"}));
}

Birthday.defaultProps = {"id":"ICONS","width":"24","height":"24","version":"1.1","viewBox":"0 0 24 24"};

module.exports = Birthday;

Birthday.default = Birthday;
